import { useEffect, useState } from "react";

import { useTemplateGroup, useFaces, useRouter, useLoading, useUsers, useShares } from "hooks";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import { appRoutes } from "routes";
import selectedCastNumber from "utils/selectedCastNumber";
import { trackTemplateView } from "tracking/google/analytics";

import View from "./View";

const InvitesPreview = () => {
  const { loadFaces } = useFaces();
  const { resetDateToShare } = useShares();
  const { loadCurrentUser } = useUsers();
  const {
    push,
    location,
    query: { slug },
  } = useRouter();
  const { loadThemedTemplateGroup, templateGroup, clearTemplateGroup } = useTemplateGroup();

  const { func: loadTemplateGroupWithLoader, isFinished: isFinishedTemplateGroup } = useLoading(
    loadThemedTemplateGroup,
  );
  const { func: loadFacesWithLoader, isFinished: isFinishedFaces } = useLoading(loadFaces);
  const { func: loadUserSession, isFinished: isUserSessionLoaded } = useLoading(loadCurrentUser);

  const [isReadyToRender, setIsReadyToRender] = useState(false);

  useEffect(() => {
    loadUserSession();
    resetDateToShare();
  }, []);

  useEffect(() => {
    if (!templateGroup || !isUserSessionLoaded) return;

    if (!TemplateGroupPresenter.isLive(templateGroup) || !TemplateGroupPresenter.hasLiveTemplates(templateGroup)) {
      push({ pathname: appRoutes.page404Path(), state: { referrer: location.pathname } });
    }

    trackTemplateView(templateGroup);
  }, [location, templateGroup, isUserSessionLoaded]);

  useEffect(() => {
    selectedCastNumber.clear();

    loadTemplateGroupWithLoader(slug).catch(() =>
      push({ pathname: appRoutes.page404Path(), state: { referrer: location.pathname } }),
    );
    loadFacesWithLoader();

    return () => clearTemplateGroup();
  }, [slug]);

  useEffect(() => {
    setIsReadyToRender(isFinishedTemplateGroup && isFinishedFaces);
  }, [isFinishedTemplateGroup, isFinishedFaces]);

  return <View loading={!isReadyToRender} templateGroup={templateGroup} />;
};

export default InvitesPreview;
